import React from "react";
import { DispatchTray } from "../../dispatchTray";
import styled from "styled-components";

const Container = styled.div`
  padding: .5rem;
`

export default function DispatchSellOrders() {
    return (
        <Container>
            <DispatchTray />
        </Container>
    );
}